import ResponsabilityTermsView from "./ResponsabilityTermsView";

export default ResponsabilityTermsView;
